(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[57330,80669],{

/***/ 65686:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "blogClient": function() { return /* binding */ blogClient; },
/* harmony export */   "blogPreviewClient": function() { return /* binding */ blogPreviewClient; },
/* harmony export */   "contentfulClient": function() { return /* binding */ contentfulClient; },
/* harmony export */   "contentfulPreviewClient": function() { return /* binding */ contentfulPreviewClient; },
/* harmony export */   "fallbackClient": function() { return /* binding */ fallbackClient; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(10253);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(97582);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var contentful__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17715);
/* harmony import */ var utils_constants__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(96076);
/* harmony import */ var utils_error__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(93250);











var ContentfulClient = function ContentfulClient(ACCESS_KEYS) {
    "use strict";
    (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this, ContentfulClient);
    var _this = this;
    (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this, "getClient", /*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function() {
        var client, error;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        (0,contentful__WEBPACK_IMPORTED_MODULE_1__/* .createClient */ .e)({
                            space: _this.SPACE,
                            environment: _this.ENVIRONMENT,
                            accessToken: _this.ACCESS_TOKEN,
                            resolveLinks: true,
                            host: _this.HOST
                        })
                    ];
                case 1:
                    client = _state.sent();
                    return [
                        2,
                        client
                    ];
                case 2:
                    error = _state.sent();
                    (0,utils_error__WEBPACK_IMPORTED_MODULE_6__/* .handleError */ .S3)({
                        error: error,
                        message: "Error in the getClient function"
                    });
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    }));
    var _this1 = this;
    (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this, "getSpace", /*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function() {
        var client, space, error;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        _this1.getClient()
                    ];
                case 1:
                    client = _state.sent();
                    return [
                        4,
                        client.getSpace()
                    ];
                case 2:
                    space = _state.sent();
                    return [
                        2,
                        space
                    ];
                case 3:
                    error = _state.sent();
                    (0,utils_error__WEBPACK_IMPORTED_MODULE_6__/* .handleError */ .S3)({
                        error: error,
                        message: "Error in the getSpace function"
                    });
                    return [
                        3,
                        4
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    }));
    var _this2 = this;
    (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this, "getEntries", function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(param) {
            var contentType, _query, query, additionalQueryParams, _searchType, searchType, queryParams, client, entries, error;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        contentType = param.contentType, _query = param.query, query = _query === void 0 ? {} : _query, additionalQueryParams = param.additionalQueryParams, _searchType = param.searchType, searchType = _searchType === void 0 ? "" : _searchType;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            4,
                            ,
                            5
                        ]);
                        queryParams = Object.entries(query).reduce(function(resultParams, param) {
                            var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(param, 2), queryKey = _param[0], queryValue = _param[1];
                            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, resultParams), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, "fields.".concat(queryKey).concat(searchType), queryValue));
                        }, {});
                        return [
                            4,
                            _this2.getClient()
                        ];
                    case 2:
                        client = _state.sent();
                        return [
                            4,
                            client.getEntries((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
                                content_type: contentType
                            }, queryParams, additionalQueryParams), {
                                include: 10
                            }))
                        ];
                    case 3:
                        entries = _state.sent();
                        if (entries.total === 0) {
                            throw new Error("404");
                        }
                        return [
                            2,
                            entries
                        ];
                    case 4:
                        error = _state.sent();
                        (0,utils_error__WEBPACK_IMPORTED_MODULE_6__/* .handleError */ .S3)({
                            error: error,
                            message: "Error in the getEntries function"
                        });
                        throw error;
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }());
    var _this3 = this;
    (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this, "getEntry", function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(id, additionalQueryParams) {
            var client, entry, error;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            _this3.getClient()
                        ];
                    case 1:
                        client = _state.sent();
                        return [
                            4,
                            client.getEntry(id, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, additionalQueryParams), {
                                include: 10
                            }))
                        ];
                    case 2:
                        entry = _state.sent();
                        return [
                            2,
                            entry
                        ];
                    case 3:
                        error = _state.sent();
                        (0,utils_error__WEBPACK_IMPORTED_MODULE_6__/* .handleError */ .S3)({
                            error: error,
                            message: "Error in the getEntry function"
                        });
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function(id, additionalQueryParams) {
            return _ref.apply(this, arguments);
        };
    }());
    var _this4 = this;
    (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this, "graphql", function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(query) {
            var response, error;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            axios__WEBPACK_IMPORTED_MODULE_0___default().post(_this4.GRAPHQL_URL, {
                                query: query
                            }, {
                                headers: {
                                    "Content-Type": "application/json",
                                    Authorization: "Bearer ".concat(_this4.ACCESS_TOKEN)
                                }
                            })
                        ];
                    case 1:
                        response = _state.sent();
                        return [
                            2,
                            response.data.data
                        ];
                    case 2:
                        error = _state.sent();
                        (0,utils_error__WEBPACK_IMPORTED_MODULE_6__/* .handleError */ .S3)({
                            error: error,
                            message: "Error in the graphql function"
                        });
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function(query) {
            return _ref.apply(this, arguments);
        };
    }());
    var space = ACCESS_KEYS.space, environment = ACCESS_KEYS.environment, accessToken = ACCESS_KEYS.accessToken, _isPreview = ACCESS_KEYS.isPreview, isPreview = _isPreview === void 0 ? false : _isPreview;
    this.SPACE = space;
    this.ENVIRONMENT = environment;
    this.ACCESS_TOKEN = accessToken;
    this.GRAPHQL_URL = "https://graphql.contentful.com/content/v1/spaces/".concat(space, "/environments/").concat(environment);
    this.HOST = isPreview ? "preview.contentful.com" : "cdn.contentful.com";
};
var contentfulClient = new ContentfulClient(utils_constants__WEBPACK_IMPORTED_MODULE_10__/* .ACCESS_TO_CONTENTFUL */ .uw);
var contentfulPreviewClient = new ContentfulClient(utils_constants__WEBPACK_IMPORTED_MODULE_10__/* .ACCESS_TO_CONTENTFUL_PREVIEW */ .I_);
var blogClient = new ContentfulClient(utils_constants__WEBPACK_IMPORTED_MODULE_10__/* .ACCESS_TO_CONTENTFUL_BLOG */ .P9);
var blogPreviewClient = new ContentfulClient(utils_constants__WEBPACK_IMPORTED_MODULE_10__/* .ACCESS_TO_CONTENTFUL_BLOG_PREVIEW */ .d6);
var fallbackClient = new ContentfulClient(utils_constants__WEBPACK_IMPORTED_MODULE_10__/* .ACCESS_TO_CONTENTFUL_FALLBACK */ .fp);


/***/ }),

/***/ 24376:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ GRAPHQL_QUERY; }
/* harmony export */ });
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41609);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_0__);

function getParam(params) {
    if (params && !lodash_isEmpty__WEBPACK_IMPORTED_MODULE_0___default()(params)) {
        var param = Object.entries(params)[0];
        return param[1] ? "".concat(param[0], ": ").concat(param[1], " ,") : "";
    }
    return "";
}
var queryfy = function(obj) {
    if (typeof obj === "number" || typeof obj === "boolean") {
        return obj;
    }
    if (Array.isArray(obj)) {
        var props = obj.map(function(value) {
            return "".concat(queryfy(value));
        }).join(",");
        return "[".concat(props, "]");
    }
    if (typeof obj === "object") {
        var props1 = Object.keys(obj).map(function(key) {
            return "".concat(key, ":").concat(queryfy(obj[key]));
        }).join(",");
        return "{".concat(props1, "}");
    }
    return JSON.stringify(obj);
};
function getFilterParams(obj) {
    if (lodash_isEmpty__WEBPACK_IMPORTED_MODULE_0___default()(obj)) {
        return "where: {}";
    }
    return "where: ".concat(queryfy(obj));
}
var GRAPHQL_QUERY = {
    loadTag: function loadTag(param) {
        var order = param.order, where = param.where;
        return "\n      query {\n        tagCollection(\n          ".concat(getParam({
            order: order
        }), "\n          ").concat(getFilterParams(where), "\n        ) {\n          items {\n            slug\n            title\n            type\n            description\n          }\n        }\n      }\n    ");
    },
    loadPreviewArticles: function loadPreviewArticles(param) {
        var limit = param.limit, order = param.order, skip = param.skip, where = param.where;
        return "\n      query {\n        articleCollection(\n          ".concat(getParam({
            limit: limit
        }), "\n          ").concat(getParam({
            order: order
        }), "\n          ").concat(getParam({
            skip: skip
        }), "\n          ").concat(getFilterParams(where), "\n        ) {\n          total\n          items {\n            title\n            slug\n            previewImageUrl {\n              url\n            }\n            tagsListCollection {\n              items {\n                slug\n              }\n            }\n            introduction\n            publishedAt\n          }\n        }\n      }\n    ");
    },
    loadPreviewPages: function loadPreviewPages(param) {
        var limit = param.limit, order = param.order, skip = param.skip, where = param.where;
        return "\n      query {\n        pageCollection(\n          ".concat(getParam({
            limit: limit
        }), "\n          ").concat(getParam({
            order: order
        }), "\n          ").concat(getParam({
            skip: skip
        }), "\n          ").concat(getFilterParams(where), "\n        ) {\n          total\n          items {\n            slug\n            pageTitle\n            metaDescription\n          }\n        }\n      }\n    ");
    },
    getNearbyArticle: function getNearbyArticle(param) {
        var limit = param.limit, order = param.order, where = param.where;
        return "\n      query {\n        articleCollection(\n          ".concat(getParam({
            limit: limit
        }), "\n          ").concat(getParam({
            order: order
        }), "\n          ").concat(getFilterParams(where), "\n        ) {\n          items {\n            title\n            slug\n            tagsListCollection {\n              items {\n                slug\n              }\n            }\n            previewImageUrl {\n              url\n            }\n          }\n        }\n      }\n    ");
    },
    getRelatedArticles: function getRelatedArticles(param) {
        var limit = param.limit, where = param.where;
        return "\n      query {\n        tagCollection(\n          ".concat(getFilterParams(where), "\n        ) {\n          items {\n            linkedFrom {\n              articleCollection(\n                ").concat(getParam({
            limit: limit
        }), "\n              ) {\n                items {\n                  title\n                  slug\n                  previewImageUrl {\n                    url\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    ");
    },
    loadPreviewArticlesByTags: function loadPreviewArticlesByTags(param) {
        var limit = param.limit, skip = param.skip, order = param.order, where = param.where;
        return "\n      query {\n        tagCollection(\n          ".concat(getFilterParams(where), "\n          ) {\n            items {\n              slug\n              linkedFrom {\n                articleCollection(\n                  ").concat(getParam({
            limit: limit
        }), "\n                  ").concat(getParam({
            skip: skip
        }), "\n                  ").concat(getParam({
            order: order
        }), "\n              ) {\n                total\n                items {\n                  title\n                  slug\n                  previewImageUrl {\n                    url\n                  }\n                  introduction\n                  publishedAt\n                }\n              }\n            }\n          }\n        }\n      }\n    ");
    },
    loadBlogBundle: function loadBlogBundle(param) {
        var pageSlug = param.pageSlug, limit = param.limit, order = param.order, skip = param.skip, isTag = param.isTag, slug = param.slug;
        var articlesQuery = "\n      articleCollection(\n        ".concat(getParam({
            limit: limit
        }), "\n        ").concat(getParam({
            order: order
        }), "\n        ").concat(getParam({
            skip: skip
        }), "\n      ) {\n        total\n        items {\n          title\n          slug\n          previewImageUrl { url }\n          tagsListCollection { items { slug } }\n          introduction\n          publishedAt\n        }\n      }\n    ");
        var articlesByTagQuery = "\n      tagCollection(\n        ".concat(getFilterParams({
            slug: slug
        }), "\n      ) {\n        items {\n          slug\n          linkedFrom {\n            articleCollection(\n              ").concat(getParam({
            limit: limit
        }), "\n              ").concat(getParam({
            order: order
        }), "\n              ").concat(getParam({
            skip: skip
        }), "\n            ) {\n              total\n              items {\n                title\n                slug\n                previewImageUrl { url }\n                introduction\n                publishedAt\n              }\n            }\n          }\n        }\n      }\n    ");
        return "\n      query {\n        tags: tagCollection { items { slug title type description } }\n        page: pageCollection(".concat(getFilterParams({
            slug: pageSlug
        }), ") {\n          items {\n            slug\n            metaTitle\n            metaDescription\n            metaRobots\n            ogImage { url }\n          }\n        }\n        ").concat(isTag ? "articlesByTag: ".concat(articlesByTagQuery) : "articles: ".concat(articlesQuery), "\n      }\n    ");
    }
};


/***/ }),

/***/ 91217:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "QX": function() { return /* binding */ getGraphqlResultTotalArticlesCount; },
/* harmony export */   "fH": function() { return /* binding */ getGraphqlResultArticles; },
/* harmony export */   "g3": function() { return /* binding */ getGraphqlResultTotalArticlesCountByTags; },
/* harmony export */   "ke": function() { return /* binding */ getGraphqlResultPages; },
/* harmony export */   "nd": function() { return /* binding */ getGraphqlResultArticlesByTags; },
/* harmony export */   "u6": function() { return /* binding */ getGraphqlResultTags; }
/* harmony export */ });
/* unused harmony exports fetchContentfulArticles, findArticlesByValue, getGraphqlResultWorkTypes */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97582);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27361);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var utils_contentful_client__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(65686);






var fetchContentfulArticles = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(isPreviewMode, additionalQuery) {
        var params, options, _tmp, error;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    params = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : {};
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        ,
                        7
                    ]);
                    options = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
                        contentType: "article",
                        additionalQueryParams: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, additionalQuery)
                    }, params);
                    if (!isPreviewMode) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        utils_contentful_client__WEBPACK_IMPORTED_MODULE_4__.contentfulPreviewClient.getEntries(options)
                    ];
                case 2:
                    _tmp = _state.sent();
                    return [
                        3,
                        5
                    ];
                case 3:
                    return [
                        4,
                        utils_contentful_client__WEBPACK_IMPORTED_MODULE_4__.contentfulClient.getEntries(options)
                    ];
                case 4:
                    _tmp = _state.sent();
                    _state.label = 5;
                case 5:
                    return [
                        2,
                        _tmp
                    ];
                case 6:
                    error = _state.sent();
                    console.error("Fetch error of articles", error);
                    return [
                        3,
                        7
                    ];
                case 7:
                    return [
                        2
                    ];
            }
        });
    });
    return function fetchContentfulArticles(isPreviewMode, additionalQuery) {
        return _ref.apply(this, arguments);
    };
}();
var findArticlesByValue = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(value) {
        var field, items, err;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    field = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : "keyWords";
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        fetchContentfulArticles((0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, "fields.".concat(field, "[match]"), value))
                    ];
                case 2:
                    items = _state.sent().items;
                    return [
                        2,
                        items
                    ];
                case 3:
                    err = _state.sent();
                    console.error("The error catched from finding articles: ");
                    return [
                        3,
                        4
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return function findArticlesByValue(value) {
        return _ref.apply(this, arguments);
    };
}();
var getGraphqlResultTags = function(graphqlResult) {
    return lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(graphqlResult, "tagCollection.items", []);
};
var getGraphqlResultWorkTypes = function(graphqlResult) {
    return get(graphqlResult, "workTypeCollection.items", []);
};
function getGraphqlResultArticles(graphqlResult) {
    return lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(graphqlResult, "articleCollection.items", []);
}
function getGraphqlResultPages(graphqlResult) {
    return lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(graphqlResult, "pageCollection.items", []);
}
function getGraphqlResultTotalArticlesCount(graphqlResult) {
    return lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(graphqlResult, "articleCollection.total", []);
}
function getGraphqlResultArticlesByTags(graphqlResult) {
    var result = lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(graphqlResult, "tagCollection.items[0].linkedFrom.articleCollection.items", []);
    result.forEach(function(item) {
        item.tagsListCollection = {
            items: [
                {
                    slug: lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(graphqlResult, "tagCollection.items[0].slug", [])
                }
            ]
        };
    });
    return result;
}
function getGraphqlResultTotalArticlesCountByTags(graphqlResult) {
    return lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(graphqlResult, "tagCollection.items[0].linkedFrom.articleCollection.total", []);
}


/***/ }),

/***/ 24654:
/***/ (function() {

/* (ignored) */

/***/ })

}]);